import { HorizontalContainer, VerticalContainer, Wrapper } from '@american-autonomy/ag-ui';

import useTranslate from 'app/i18n/useTranslate';

import { STEPS, TEST_ID } from './constants';
import type { FunctionComponent, Props, StepStatus } from './types';

import styles from './styles.module.scss';

const getStepStatus = ({
    currentStep,
    rowIndex
}: {
    rowIndex: number;
    currentStep: number;
}): StepStatus => {
    if (rowIndex < currentStep) {
        return 'done';
    }

    if (rowIndex === currentStep) {
        return 'inProgress';
    }

    return 'pending';
};

const PILL_STATUS_CLASS: Record<StepStatus, string> = {
    done: styles.pillDone,
    inProgress: styles.pillInProgress,
    pending: styles.pillPending
};

const LABEL_STATUS_CLASS: Record<StepStatus, string> = {
    done: styles.labelDone,
    inProgress: styles.labelInProgress,
    pending: styles.labelPending
};

const ExportProgressList: FunctionComponent<Props> = ({ currentStep, testId = TEST_ID }) => {
    const translate = useTranslate('johnDeereExportModal');

    return (
        <VerticalContainer className={styles.exportProgressList} testId={testId}>
            {STEPS.map(({ stepNumber, translationKey }) => {
                const status = getStepStatus({ currentStep, rowIndex: stepNumber });
                const pillClass = PILL_STATUS_CLASS[status];
                const labelClass = LABEL_STATUS_CLASS[status];
                const labelText = translate(translationKey);

                return (
                    <HorizontalContainer className={styles.row} key={stepNumber}>
                        <Wrapper className={`${styles.pill} ${pillClass}`} />

                        <Wrapper className={`${styles.label} ${labelClass}`}>{labelText}</Wrapper>
                    </HorizontalContainer>
                );
            })}
        </VerticalContainer>
    );
};

export default ExportProgressList;
